// @ts-nocheck
import { orgInitialApi as api } from './initialApi';
export const addTagTypes = [
  'organization-v-2-controller',
  'fleets-v-2-controller',
  'migration-controller',
  'close-org-controller',
  'enrollment-controller',
  'caps-controller',
  'hubs-v-2-controller',
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getPartnerId: build.query<GetPartnerIdApiResponse, GetPartnerIdApiArg>({
        query: (queryArg) => ({
          url: `/2026-08-11/${queryArg.orgId}/partnerId`,
        }),
        providesTags: ['organization-v-2-controller'],
      }),
      updatePartnerId: build.mutation<
        UpdatePartnerIdApiResponse,
        UpdatePartnerIdApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-08-11/${queryArg.orgId}/partnerId`,
          method: 'PUT',
          body: queryArg.partnerIdUpdateRequest,
        }),
        invalidatesTags: ['organization-v-2-controller'],
      }),
      updateVerificationStatus: build.mutation<
        UpdateVerificationStatusApiResponse,
        UpdateVerificationStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-06-02/admin/${queryArg.orgId}/verification-status`,
          method: 'PUT',
          body: queryArg.verificationStatusUpdateRequest,
        }),
        invalidatesTags: ['organization-v-2-controller'],
      }),
      getAutoOnboardingSettings: build.query<
        GetAutoOnboardingSettingsApiResponse,
        GetAutoOnboardingSettingsApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-05-19/${queryArg.orgId}/settings/auto-onboarding`,
        }),
        providesTags: ['organization-v-2-controller'],
      }),
      updateAutoOnboardingSettings: build.mutation<
        UpdateAutoOnboardingSettingsApiResponse,
        UpdateAutoOnboardingSettingsApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-05-19/${queryArg.orgId}/settings/auto-onboarding`,
          method: 'PUT',
          body: queryArg.autoOnboardingSettingsUpdateRequest,
        }),
        invalidatesTags: ['organization-v-2-controller'],
      }),
      updateFleetV20250114: build.mutation<
        UpdateFleetV20250114ApiResponse,
        UpdateFleetV20250114ApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-01-14/${queryArg.organizationId}/fleets/${queryArg.fleetId}`,
          method: 'PUT',
          body: queryArg.fleetUpdateRequestV20250115,
        }),
        invalidatesTags: ['fleets-v-2-controller'],
      }),
      updateOrganizationV20241204: build.mutation<
        UpdateOrganizationV20241204ApiResponse,
        UpdateOrganizationV20241204ApiArg
      >({
        query: (queryArg) => ({
          url: `/2024-12-04/${queryArg.orgId}`,
          method: 'PUT',
          body: queryArg.organizationUpdateRequestV20241204,
        }),
        invalidatesTags: ['organization-v-2-controller'],
      }),
      updateOrganizationV20230717: build.mutation<
        UpdateOrganizationV20230717ApiResponse,
        UpdateOrganizationV20230717ApiArg
      >({
        query: (queryArg) => ({
          url: `/2023-07-17/${queryArg.orgId}`,
          method: 'PUT',
          body: queryArg.organizationUpdateRequest,
        }),
        invalidatesTags: ['organization-v-2-controller'],
      }),
      updateFleetsByOrganizationIdAndFleetId: build.mutation<
        UpdateFleetsByOrganizationIdAndFleetIdApiResponse,
        UpdateFleetsByOrganizationIdAndFleetIdApiArg
      >({
        query: (queryArg) => ({
          url: `/2021-11-15/${queryArg.orgId}/fleets/${queryArg.fleetId}`,
          method: 'PUT',
          body: queryArg.fleetUpdateRequest,
        }),
        invalidatesTags: ['organization-v-2-controller'],
      }),
      syncOviTrialSubscription: build.mutation<
        SyncOviTrialSubscriptionApiResponse,
        SyncOviTrialSubscriptionApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-09-08/migration/ovi/subscriptions/trials`,
          method: 'POST',
          body: queryArg.syncOviTrialSubscriptionRequest,
          headers: {
            'FORCE-CHANGE': queryArg['FORCE-CHANGE'],
          },
        }),
        invalidatesTags: ['migration-controller'],
      }),
      validateMigratedOviTrialStartDate: build.mutation<
        ValidateMigratedOviTrialStartDateApiResponse,
        ValidateMigratedOviTrialStartDateApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-09-08/migration/ovi/subscriptions/trials/validate`,
          method: 'POST',
          body: queryArg.validateMigratedOviTrialStartDateRequest,
        }),
        invalidatesTags: ['migration-controller'],
      }),
      closeOrganization: build.mutation<
        CloseOrganizationApiResponse,
        CloseOrganizationApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-07-28/${queryArg.organizationId}/close`,
          method: 'POST',
        }),
        invalidatesTags: ['close-org-controller'],
      }),
      reconcileCloseOrganizations: build.mutation<
        ReconcileCloseOrganizationsApiResponse,
        ReconcileCloseOrganizationsApiArg
      >({
        query: () => ({
          url: `/2026-07-28/closeorg/reconcile`,
          method: 'POST',
        }),
        invalidatesTags: ['close-org-controller'],
      }),
      verifyFan: build.mutation<VerifyFanApiResponse, VerifyFanApiArg>({
        query: (queryArg) => ({
          url: `/2026-06-30/${queryArg.orgId}/verify-fan`,
          method: 'POST',
          body: queryArg.verifyFanRequest,
        }),
        invalidatesTags: ['enrollment-controller'],
      }),
      validateMigratedOviFleets: build.mutation<
        ValidateMigratedOviFleetsApiResponse,
        ValidateMigratedOviFleetsApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-06-16/migration/ovi/fleets/validate`,
          method: 'POST',
          body: queryArg.validateMigratedOviFleetsRequest,
        }),
        invalidatesTags: ['migration-controller'],
      }),
      validateMigratedOviBusinessAccount: build.mutation<
        ValidateMigratedOviBusinessAccountApiResponse,
        ValidateMigratedOviBusinessAccountApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-06-16/migration/ovi/accounts/validate`,
          method: 'POST',
          body: queryArg.validateMigratedOviBusinessAccountRequest,
        }),
        invalidatesTags: ['migration-controller'],
      }),
      submitEnrollment: build.mutation<
        SubmitEnrollmentApiResponse,
        SubmitEnrollmentApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-06-16/enrollment/submit`,
          method: 'POST',
          body: queryArg.enrollmentSubmitRequest,
        }),
        invalidatesTags: ['enrollment-controller'],
      }),
      getMigratedOviFleets: build.query<
        GetMigratedOviFleetsApiResponse,
        GetMigratedOviFleetsApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-06-02/migration/ovi/fleets`,
          headers: {
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            oviAccountId: queryArg.oviAccountId,
            oviFleetId: queryArg.oviFleetId,
            organizationId: queryArg.organizationId,
            fleetId: queryArg.fleetId,
            size: queryArg.size,
          },
        }),
        providesTags: ['migration-controller'],
      }),
      syncOviFleets: build.mutation<
        SyncOviFleetsApiResponse,
        SyncOviFleetsApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-06-02/migration/ovi/fleets`,
          method: 'POST',
          body: queryArg.syncOviFleetRequest,
          headers: {
            'FORCE-CHANGE': queryArg['FORCE-CHANGE'],
          },
        }),
        invalidatesTags: ['migration-controller'],
      }),
      activateOrganization: build.mutation<
        ActivateOrganizationApiResponse,
        ActivateOrganizationApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-06-02/migration/ovi/accounts/activate`,
          method: 'POST',
          body: queryArg.activateOrganizationRequest,
        }),
        invalidatesTags: ['migration-controller'],
      }),
      lookupEnrollment: build.mutation<
        LookupEnrollmentApiResponse,
        LookupEnrollmentApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-05-19/enrollment/lookup`,
          method: 'POST',
          body: queryArg.enrollmentUnifiedLookupRequest,
        }),
        invalidatesTags: ['enrollment-controller'],
      }),
      syncOviBusinessAccount: build.mutation<
        SyncOviBusinessAccountApiResponse,
        SyncOviBusinessAccountApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-05-05/migration/ovi/accounts/${queryArg.accountId}`,
          method: 'POST',
          body: queryArg.syncOviBusinessAccountRequest,
          headers: {
            'FORCE-CHANGE': queryArg['FORCE-CHANGE'],
          },
        }),
        invalidatesTags: ['migration-controller'],
      }),
      getOrganizationsInfoV20260120: build.mutation<
        GetOrganizationsInfoV20260120ApiResponse,
        GetOrganizationsInfoV20260120ApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-01-13/view`,
          method: 'POST',
          body: queryArg.organizationViewRequest,
        }),
        invalidatesTags: ['organization-v-2-controller'],
      }),
      lookupOrganizationByInfo: build.mutation<
        LookupOrganizationByInfoApiResponse,
        LookupOrganizationByInfoApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-07-15/lookup`,
          method: 'POST',
          body: queryArg.organizationLookupRequest,
        }),
        invalidatesTags: ['enrollment-controller'],
      }),
      lookupOrganizationByRawAddressInfo: build.mutation<
        LookupOrganizationByRawAddressInfoApiResponse,
        LookupOrganizationByRawAddressInfoApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-07-15/lookup-raw-address`,
          method: 'POST',
          body: queryArg.organizationLookupRequestRawAddress,
        }),
        invalidatesTags: ['enrollment-controller'],
      }),
      enrollAutomatic: build.mutation<
        EnrollAutomaticApiResponse,
        EnrollAutomaticApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-07-15/enroll`,
          method: 'POST',
          body: queryArg.odiMatchConfirmation,
        }),
        invalidatesTags: ['enrollment-controller'],
      }),
      enrollForReview: build.mutation<
        EnrollForReviewApiResponse,
        EnrollForReviewApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-07-15/enroll-no-match`,
          method: 'POST',
          body: queryArg.enrollNoMatchRequest,
        }),
        invalidatesTags: ['enrollment-controller'],
      }),
      acceptTerms: build.mutation<AcceptTermsApiResponse, AcceptTermsApiArg>({
        query: (queryArg) => ({
          url: `/2025-02-11/${queryArg.orgId}/terms`,
          method: 'POST',
          body: queryArg.termsRequestV20250211,
        }),
        invalidatesTags: ['organization-v-2-controller'],
      }),
      enrollAsCustomer: build.mutation<
        EnrollAsCustomerApiResponse,
        EnrollAsCustomerApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-01-14/enroll`,
          method: 'POST',
          body: queryArg.enrollmentRequest,
        }),
        invalidatesTags: ['enrollment-controller'],
      }),
      declineEnrollment: build.mutation<
        DeclineEnrollmentApiResponse,
        DeclineEnrollmentApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-01-14/admin/enrollments/${queryArg.id}/decline`,
          method: 'POST',
          body: queryArg.enrollmentDeclineRequest,
        }),
        invalidatesTags: ['enrollment-controller'],
      }),
      approveEnrollment: build.mutation<
        ApproveEnrollmentApiResponse,
        ApproveEnrollmentApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-01-14/admin/enrollments/${queryArg.id}/approve`,
          method: 'POST',
          params: {
            skipAdminCreation: queryArg.skipAdminCreation,
            orgType: queryArg.orgType,
          },
        }),
        invalidatesTags: ['enrollment-controller'],
      }),
      enrollAsAdmin: build.mutation<
        EnrollAsAdminApiResponse,
        EnrollAsAdminApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-01-14/admin/enroll`,
          method: 'POST',
          body: queryArg.adminEnrollmentRequest,
        }),
        invalidatesTags: ['enrollment-controller'],
      }),
      updateOrgDefaultFleet: build.mutation<
        UpdateOrgDefaultFleetApiResponse,
        UpdateOrgDefaultFleetApiArg
      >({
        query: (queryArg) => ({
          url: `/2024-12-17/${queryArg.id}/defaultFleet`,
          method: 'POST',
          body: queryArg.updateDefaultFleetRequest,
        }),
        invalidatesTags: ['organization-v-2-controller'],
      }),
      createFleet: build.mutation<CreateFleetApiResponse, CreateFleetApiArg>({
        query: (queryArg) => ({
          url: `/2024-09-26/${queryArg.organizationId}/fleets`,
          method: 'POST',
          body: queryArg.fleetCreateRequestV20240926,
        }),
        invalidatesTags: ['fleets-v-2-controller'],
      }),
      checkIfFleetConfigHasChanged: build.mutation<
        CheckIfFleetConfigHasChangedApiResponse,
        CheckIfFleetConfigHasChangedApiArg
      >({
        query: (queryArg) => ({
          url: `/2021-11-15/${queryArg.organizationId}/hubs/${queryArg.hubId}/fleets/${queryArg.fleetId}/configs`,
          method: 'POST',
          body: queryArg.configChangeCheckRequest,
          params: {
            action: queryArg.action,
          },
        }),
        invalidatesTags: ['fleets-v-2-controller'],
      }),
      getOrganizationsInfo: build.mutation<
        GetOrganizationsInfoApiResponse,
        GetOrganizationsInfoApiArg
      >({
        query: (queryArg) => ({
          url: `/2021-11-15/view`,
          method: 'POST',
          body: queryArg.organizationViewRequest,
        }),
        invalidatesTags: ['organization-v-2-controller'],
      }),
      getCloseStatus: build.query<
        GetCloseStatusApiResponse,
        GetCloseStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-07-28/${queryArg.organizationId}/close-status`,
        }),
        providesTags: ['close-org-controller'],
      }),
      getEnrollmentStatus: build.query<
        GetEnrollmentStatusApiResponse,
        GetEnrollmentStatusApiArg
      >({
        query: () => ({ url: `/2026-07-28/enrollment/status` }),
        providesTags: ['enrollment-controller'],
      }),
      getMigratedOviAccounts: build.query<
        GetMigratedOviAccountsApiResponse,
        GetMigratedOviAccountsApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-06-02/migration/ovi/accounts`,
          headers: {
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            oviAccountId: queryArg.oviAccountId,
            organizationId: queryArg.organizationId,
            size: queryArg.size,
          },
        }),
        providesTags: ['migration-controller'],
      }),
      getOrganizationFanDetails: build.query<
        GetOrganizationFanDetailsApiResponse,
        GetOrganizationFanDetailsApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-04-21/fans`,
          params: {
            organizationIds: queryArg.organizationIds,
          },
        }),
        providesTags: ['organization-v-2-controller'],
      }),
      getOrganizationByOrgId: build.query<
        GetOrganizationByOrgIdApiResponse,
        GetOrganizationByOrgIdApiArg
      >({
        query: (queryArg) => ({ url: `/2025-01-14/${queryArg.orgId}` }),
        providesTags: ['organization-v-2-controller'],
      }),
      getAllFleets: build.query<GetAllFleetsApiResponse, GetAllFleetsApiArg>({
        query: (queryArg) => ({
          url: `/2024-12-17/${queryArg.organizationId}/fleets`,
          headers: {
            continuationToken: queryArg.continuationToken,
          },
          params: {
            size: queryArg.size,
            fleetName: queryArg.fleetName,
          },
        }),
        providesTags: ['fleets-v-2-controller'],
      }),
      getFleetById: build.query<GetFleetByIdApiResponse, GetFleetByIdApiArg>({
        query: (queryArg) => ({
          url: `/2024-12-17/${queryArg.organizationId}/fleets/${queryArg.fleetId}`,
        }),
        providesTags: ['fleets-v-2-controller'],
      }),
      getAllOrganizations: build.query<
        GetAllOrganizationsApiResponse,
        GetAllOrganizationsApiArg
      >({
        query: (queryArg) => ({
          url: `/2024-11-20`,
          headers: {
            continuationToken: queryArg.continuationToken,
          },
          params: {
            name: queryArg.name,
            fan: queryArg.fan,
            email: queryArg.email,
            statuses: queryArg.statuses,
            size: queryArg.size,
          },
        }),
        providesTags: ['organization-v-2-controller'],
      }),
      getOrgById: build.query<GetOrgByIdApiResponse, GetOrgByIdApiArg>({
        query: (queryArg) => ({ url: `/2024-11-20/${queryArg.id}` }),
        providesTags: ['organization-v-2-controller'],
      }),
      getCapDetails: build.query<GetCapDetailsApiResponse, GetCapDetailsApiArg>(
        {
          query: (queryArg) => ({
            url: `/2024-10-08/caps`,
            headers: {
              'x-bd-organization': queryArg['x-bd-organization'],
            },
          }),
          providesTags: ['caps-controller'],
        }
      ),
      getDocument: build.query<GetDocumentApiResponse, GetDocumentApiArg>({
        query: (queryArg) => ({
          url: `/2024-10-08/caps/pdfs/${queryArg.documentId}`,
          headers: {
            'x-bd-organization': queryArg['x-bd-organization'],
          },
        }),
        providesTags: ['caps-controller'],
      }),
      getAllOrganizationsWithType: build.query<
        GetAllOrganizationsWithTypeApiResponse,
        GetAllOrganizationsWithTypeApiArg
      >({
        query: () => ({ url: `/2023-07-17` }),
        providesTags: ['organization-v-2-controller'],
      }),
      getOrganizationByIdWithType: build.query<
        GetOrganizationByIdWithTypeApiResponse,
        GetOrganizationByIdWithTypeApiArg
      >({
        query: (queryArg) => ({ url: `/2023-07-17/${queryArg.id}` }),
        providesTags: ['organization-v-2-controller'],
      }),
      getFleetByIdV2: build.query<
        GetFleetByIdV2ApiResponse,
        GetFleetByIdV2ApiArg
      >({
        query: (queryArg) => ({
          url: `/2023-05-09/${queryArg.organizationId}/hubs/${queryArg.hubId}/fleets/${queryArg.fleetId}`,
        }),
        providesTags: ['fleets-v-2-controller'],
      }),
      getAllOrganizations1: build.query<
        GetAllOrganizations1ApiResponse,
        GetAllOrganizations1ApiArg
      >({
        query: () => ({ url: `/2021-11-15` }),
        providesTags: ['organization-v-2-controller'],
      }),
      getAllHubs: build.query<GetAllHubsApiResponse, GetAllHubsApiArg>({
        query: (queryArg) => ({
          url: `/2021-11-15/${queryArg.organizationId}/hubs`,
        }),
        providesTags: ['hubs-v-2-controller'],
      }),
      getHubById: build.query<GetHubByIdApiResponse, GetHubByIdApiArg>({
        query: (queryArg) => ({
          url: `/2021-11-15/${queryArg.organizationId}/hubs/${queryArg.hubId}`,
        }),
        providesTags: ['hubs-v-2-controller'],
      }),
      getAllFleets1: build.query<GetAllFleets1ApiResponse, GetAllFleets1ApiArg>(
        {
          query: (queryArg) => ({
            url: `/2021-11-15/${queryArg.organizationId}/hubs/${queryArg.hubId}/fleets`,
          }),
          providesTags: ['fleets-v-2-controller'],
        }
      ),
      getFleetById1: build.query<GetFleetById1ApiResponse, GetFleetById1ApiArg>(
        {
          query: (queryArg) => ({
            url: `/2021-11-15/${queryArg.organizationId}/hubs/${queryArg.hubId}/fleets/${queryArg.fleetId}`,
          }),
          providesTags: ['fleets-v-2-controller'],
        }
      ),
      getFleetChildren: build.query<
        GetFleetChildrenApiResponse,
        GetFleetChildrenApiArg
      >({
        query: (queryArg) => ({
          url: `/2021-11-15/${queryArg.organizationId}/hubs/${queryArg.hubId}/fleets/${queryArg.fleetId}/children`,
        }),
        providesTags: ['fleets-v-2-controller'],
      }),
      getHubChildren: build.query<
        GetHubChildrenApiResponse,
        GetHubChildrenApiArg
      >({
        query: (queryArg) => ({
          url: `/2021-11-15/${queryArg.organizationId}/hubs/${queryArg.hubId}/children`,
        }),
        providesTags: ['hubs-v-2-controller'],
      }),
      getOrganizationChildren: build.query<
        GetOrganizationChildrenApiResponse,
        GetOrganizationChildrenApiArg
      >({
        query: (queryArg) => ({
          url: `/2021-11-15/${queryArg.orgId}/children`,
        }),
        providesTags: ['organization-v-2-controller'],
      }),
      getOrganizationById: build.query<
        GetOrganizationByIdApiResponse,
        GetOrganizationByIdApiArg
      >({
        query: (queryArg) => ({ url: `/2021-11-15/${queryArg.id}` }),
        providesTags: ['organization-v-2-controller'],
      }),
      getOrganizationStatsById: build.query<
        GetOrganizationStatsByIdApiResponse,
        GetOrganizationStatsByIdApiArg
      >({
        query: (queryArg) => ({ url: `/2021-11-15/${queryArg.id}/stats` }),
        providesTags: ['organization-v-2-controller'],
      }),
      getAllFleetsByOrganizationId: build.query<
        GetAllFleetsByOrganizationIdApiResponse,
        GetAllFleetsByOrganizationIdApiArg
      >({
        query: (queryArg) => ({ url: `/2021-11-15/${queryArg.id}/fleets` }),
        providesTags: ['organization-v-2-controller'],
      }),
      getTopLevelOrganizations: build.query<
        GetTopLevelOrganizationsApiResponse,
        GetTopLevelOrganizationsApiArg
      >({
        query: () => ({ url: `/2021-11-15/tenants` }),
        providesTags: ['organization-v-2-controller'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as organizationsApi };
export type GetPartnerIdApiResponse =
  /** status 200 Successfully retrieved partner id. */ GmResponseCommonOrganizationPartnerIdResponse;
export type GetPartnerIdApiArg = {
  /** Organization's identification. */
  orgId: string;
};
export type UpdatePartnerIdApiResponse =
  /** status 200 Successfully updated partner id. */ GmResponseCommonOrganizationPartnerIdResponse;
export type UpdatePartnerIdApiArg = {
  /** ID of the organization to update */
  orgId: string;
  partnerIdUpdateRequest: PartnerIdUpdateRequest;
};
export type UpdateVerificationStatusApiResponse =
  /** status 200 Successfully updated verification status. */ GmResponseCommonOrganizationResponseV20241120;
export type UpdateVerificationStatusApiArg = {
  /** ID of the organization to update */
  orgId: string;
  verificationStatusUpdateRequest: VerificationStatusUpdateRequest;
};
export type GetAutoOnboardingSettingsApiResponse =
  /** status 200 Successfully retrieved auto-onboarding settings. */ GmResponseCommonAutoOnboardingSettingsResponse;
export type GetAutoOnboardingSettingsApiArg = {
  orgId: string;
};
export type UpdateAutoOnboardingSettingsApiResponse =
  /** status 200 Successfully updated auto-onboarding settings. */ GmResponseCommonAutoOnboardingSettingsResponse;
export type UpdateAutoOnboardingSettingsApiArg = {
  orgId: string;
  autoOnboardingSettingsUpdateRequest: AutoOnboardingSettingsUpdateRequest;
};
export type UpdateFleetV20250114ApiResponse =
  /** status 200 Successfully updated fleet. */ GmResponseCommonFleetResponse;
export type UpdateFleetV20250114ApiArg = {
  organizationId: string;
  fleetId: string;
  fleetUpdateRequestV20250115: FleetUpdateRequestV20250115;
};
export type UpdateOrganizationV20241204ApiResponse =
  /** status 200 Successfully updated organization. */ GmResponseCommonOrganizationResponseV20241120;
export type UpdateOrganizationV20241204ApiArg = {
  /** ID of the organization to update */
  orgId: string;
  organizationUpdateRequestV20241204: OrganizationUpdateRequestV20241204;
};
export type UpdateOrganizationV20230717ApiResponse =
  /** status 200 Successfully updated organization. */ GmResponseCommonOrganizationResponseV20230717;
export type UpdateOrganizationV20230717ApiArg = {
  /** ID of the organization to update */
  orgId: string;
  organizationUpdateRequest: OrganizationUpdateRequest;
};
export type UpdateFleetsByOrganizationIdAndFleetIdApiResponse =
  /** status 200 OK */ GmResponseCommonFleetConfigurationResponse;
export type UpdateFleetsByOrganizationIdAndFleetIdApiArg = {
  /** organization id for fleet's parent */
  orgId: string;
  /** fleet id */
  fleetId: string;
  fleetUpdateRequest: FleetUpdateRequest;
};
export type SyncOviTrialSubscriptionApiResponse =
  /** status 200 Successfully synced OVI trial subscription. */ GmResponseCommonSyncOviTrialSubscriptionResponse;
export type SyncOviTrialSubscriptionApiArg = {
  /** If true, forces the change regardless of existing state. */
  'FORCE-CHANGE'?: boolean;
  syncOviTrialSubscriptionRequest: SyncOviTrialSubscriptionRequest;
};
export type ValidateMigratedOviTrialStartDateApiResponse =
  /** status 200 Validation completed. */ GmResponseCommonValidateMigratedOviTrialStartDateResponse;
export type ValidateMigratedOviTrialStartDateApiArg = {
  validateMigratedOviTrialStartDateRequest: ValidateMigratedOviTrialStartDateRequest;
};
export type CloseOrganizationApiResponse =
  /** status 202 Close accepted; returns the durable accepted snapshot without live progress. */ GmResponseCommonCloseAcceptedResponse;
export type CloseOrganizationApiArg = {
  /** ID of the organization to close */
  organizationId: string;
};
export type ReconcileCloseOrganizationsApiResponse =
  /** status 200 Sweep completed; returns what it did. */ GmResponseCommonCloseOrgReconciliationOutcome;
export type ReconcileCloseOrganizationsApiArg = void;
export type VerifyFanApiResponse =
  /** status 200 FAN verified — returns updated verification details. */ GmResponseCommonVerifyFanResponse;
export type VerifyFanApiArg = {
  orgId: string;
  verifyFanRequest: VerifyFanRequest;
};
export type ValidateMigratedOviFleetsApiResponse =
  /** status 200 Validation completed. */ GmResponseCommonValidateMigratedOviFleetsResponse;
export type ValidateMigratedOviFleetsApiArg = {
  validateMigratedOviFleetsRequest: ValidateMigratedOviFleetsRequest;
};
export type ValidateMigratedOviBusinessAccountApiResponse =
  /** status 200 Validation completed. */ GmResponseCommonValidateMigratedOviBusinessAccountResponse;
export type ValidateMigratedOviBusinessAccountApiArg = {
  validateMigratedOviBusinessAccountRequest: ValidateMigratedOviBusinessAccountRequest;
};
export type SubmitEnrollmentApiResponse =
  /** status 201 Enrollment approved and organization activated (FAN: VERIFIED; name+address: PARTIALLY_VERIFIED). */ GmResponseCommonEnrollmentSubmissionResponse;
export type SubmitEnrollmentApiArg = {
  enrollmentSubmitRequest: EnrollmentSubmitRequest;
};
export type GetMigratedOviFleetsApiResponse =
  /** status 200 Successfully retrieved OVI fleets. */ GmResponseCommonGmPageOrganizationEntityDto;
export type GetMigratedOviFleetsApiArg = {
  /** OVI business account ID. */
  oviAccountId?: string;
  /** OVI fleet account ID. */
  oviFleetId?: string;
  /** CSP organization ID. */
  organizationId?: string;
  /** CSP fleet ID. */
  fleetId?: string;
  /** Number of records per page. Default is 10, max is 100. */
  size?: number;
  /** Continuation token for pagination. */
  'cs-continuation-token'?: string;
};
export type SyncOviFleetsApiResponse =
  /** status 200 Successfully processed OVI fleets. */ GmResponseCommonSyncOviFleetResponse;
export type SyncOviFleetsApiArg = {
  /** If true, forces the change regardless of existing state. */
  'FORCE-CHANGE'?: boolean;
  syncOviFleetRequest: SyncOviFleetRequest;
};
export type ActivateOrganizationApiResponse =
  /** status 200 Successfully activated organization. */ GmResponseCommonActivateOrganizationResponse;
export type ActivateOrganizationApiArg = {
  activateOrganizationRequest: ActivateOrganizationRequest;
};
export type LookupEnrollmentApiResponse =
  /** status 200 Lookup successful — returns candidate list. */ GmResponseCommonEnrollmentLookupResponse;
export type LookupEnrollmentApiArg = {
  enrollmentUnifiedLookupRequest: EnrollmentUnifiedLookupRequest;
};
export type SyncOviBusinessAccountApiResponse =
  /** status 200 Successfully synced OVI account. */ GmResponseCommonSyncOviBusinessAccountResponse;
export type SyncOviBusinessAccountApiArg = {
  /** If true, forces the change regardless of existing state. */
  'FORCE-CHANGE'?: boolean;
  accountId: string;
  syncOviBusinessAccountRequest: SyncOviBusinessAccountRequest;
};
export type GetOrganizationsInfoV20260120ApiResponse =
  /** status 200 OK */ GmResponseCommonOrganizationViewResponseV20260113;
export type GetOrganizationsInfoV20260120ApiArg = {
  organizationViewRequest: OrganizationViewRequest;
};
export type LookupOrganizationByInfoApiResponse =
  /** status 200 Lookup performed successfully. */ GmResponseCommonCspCandidate;
export type LookupOrganizationByInfoApiArg = {
  organizationLookupRequest: OrganizationLookupRequest;
};
export type LookupOrganizationByRawAddressInfoApiResponse =
  /** status 200 ODI returned a successful raw-address lookup payload. */ GmResponseCommonOrganizationLookupRawAddressResponse;
export type LookupOrganizationByRawAddressInfoApiArg = {
  organizationLookupRequestRawAddress: OrganizationLookupRequestRawAddress;
};
export type EnrollAutomaticApiResponse =
  /** status 201 Successfully submitted enrollment. */ GmResponseCommonEnrollmentSubmissionResponse;
export type EnrollAutomaticApiArg = {
  odiMatchConfirmation: OdiMatchConfirmation;
};
export type EnrollForReviewApiResponse =
  /** status 201 Enrollment application submitted to advisor. */ GmResponseCommonEnrollmentSubmissionResponse;
export type EnrollForReviewApiArg = {
  enrollNoMatchRequest: EnrollNoMatchRequest;
};
export type AcceptTermsApiResponse =
  /** status 200 OK */ GmResponseCommonTermsResponseV20250211;
export type AcceptTermsApiArg = {
  /** The id of the organization to accept terms for. */
  orgId: string;
  termsRequestV20250211: TermsRequestV20250211;
};
export type EnrollAsCustomerApiResponse =
  /** status 201 Successfully submitted enrollment. */ GmResponseCommonEnrollmentSubmissionResponse;
export type EnrollAsCustomerApiArg = {
  enrollmentRequest: EnrollmentRequest;
};
export type DeclineEnrollmentApiResponse =
  /** status 200 Successfully declined enrollment. */ GmResponseCommonVoid;
export type DeclineEnrollmentApiArg = {
  id: string;
  enrollmentDeclineRequest: EnrollmentDeclineRequest;
};
export type ApproveEnrollmentApiResponse =
  /** status 200 Successfully approved enrollment. */ GmResponseCommonVoid;
export type ApproveEnrollmentApiArg = {
  /** If true, skips the creation of the admin user for the organization. */
  skipAdminCreation?: boolean;
  /** Classification of the organization for analytics and filtering. Omit to leave unchanged. */
  orgType?: 'TEST' | 'DEMO' | 'DEALER' | 'CUSTOMER';
  id: string;
};
export type EnrollAsAdminApiResponse =
  /** status 201 Successfully submitted enrollment. */ GmResponseCommonEnrollmentSubmissionResponse;
export type EnrollAsAdminApiArg = {
  adminEnrollmentRequest: AdminEnrollmentRequest;
};
export type UpdateOrgDefaultFleetApiResponse =
  /** status 200 Successfully updated organization. */ GmResponseCommonOrganizationResponseV20241120;
export type UpdateOrgDefaultFleetApiArg = {
  id: string;
  updateDefaultFleetRequest: UpdateDefaultFleetRequest;
};
export type CreateFleetApiResponse =
  /** status 201 Successfully created fleet. */ GmResponseCommonFleetCreateResponse;
export type CreateFleetApiArg = {
  organizationId: string;
  fleetCreateRequestV20240926: FleetCreateRequestV20240926;
};
export type CheckIfFleetConfigHasChangedApiResponse =
  /** status 200 Successful Operation */ boolean;
export type CheckIfFleetConfigHasChangedApiArg = {
  organizationId: string;
  hubId: string;
  fleetId: string;
  action: string;
  configChangeCheckRequest: ConfigChangeCheckRequest;
};
export type GetOrganizationsInfoApiResponse =
  /** status 200 OK */ GmResponseCommonOrganizationsViewResponse;
export type GetOrganizationsInfoApiArg = {
  organizationViewRequest: OrganizationViewRequest;
};
export type GetCloseStatusApiResponse =
  /** status 200 Current close status returned with best-effort live progress detail. */ GmResponseCommonCloseStatusResponse;
export type GetCloseStatusApiArg = {
  /** ID of the organization whose close status is requested */
  organizationId: string;
};
export type GetEnrollmentStatusApiResponse =
  /** status 200 Enrollment status resolved (existingEnrollment true/false). */ GmResponseCommonEnrollmentStatusResponse;
export type GetEnrollmentStatusApiArg = void;
export type GetMigratedOviAccountsApiResponse =
  /** status 200 Successfully retrieved OVI accounts. */ GmResponseCommonGmPageOrganizationDto;
export type GetMigratedOviAccountsApiArg = {
  /** OVI business account ID. */
  oviAccountId?: string;
  /** CSP organization ID. */
  organizationId?: string;
  /** Number of records per page. Default is 10, max is 100. */
  size?: number;
  /** Continuation token for pagination. */
  'cs-continuation-token'?: string;
};
export type GetOrganizationFanDetailsApiResponse =
  /** status 200 OK */ GmResponseCommonListOrganizationFanResponse;
export type GetOrganizationFanDetailsApiArg = {
  /** Optional list of organization IDs to filter by. */
  organizationIds?: string[];
};
export type GetOrganizationByOrgIdApiResponse =
  /** status 200 OK */ GmResponseCommonOrganizationDto;
export type GetOrganizationByOrgIdApiArg = {
  /** Organization's identification. */
  orgId: string;
};
export type GetAllFleetsApiResponse =
  /** status 200 Successfully retrieved fleets. */ GmResponseCommonGmPageFleetResponse;
export type GetAllFleetsApiArg = {
  /** Organization ID. */
  organizationId: string;
  /** Number of fleets to return. */
  size?: number;
  /** Token to continue fetching fleets. */
  continuationToken?: string;
  /** Filter fleets by name. */
  fleetName?: string;
};
export type GetFleetByIdApiResponse =
  /** status 200 OK */ GmResponseCommonFleetResponse;
export type GetFleetByIdApiArg = {
  organizationId: string;
  fleetId: string;
};
export type GetAllOrganizationsApiResponse =
  /** status 200 Successfully retrieved organizations. */ GmResponseCommonPaginatedDataResponseOrganizationResponseV20241120;
export type GetAllOrganizationsApiArg = {
  /** The name of the organization to search for. */
  name?: string;
  /** The fan of the organization to search for. */
  fan?: string;
  /** The primary email address of the organization to search for. */
  email?: string;
  /** Filter by list of organizations status. */
  statuses?: (
    | 'DRAFT'
    | 'PENDING'
    | 'ENROLLING'
    | 'ACTIVE'
    | 'DISABLED'
    | 'DELETED'
    | 'ABORTED'
    | 'RETIRED'
    | 'CLOSING'
    | 'CLOSED'
  )[];
  /** Number of organizations to return. */
  size?: number;
  /** Token to continue fetching organizations. */
  continuationToken?: string;
};
export type GetOrgByIdApiResponse =
  /** status 200 Successfully retrieved organization. */ GmResponseCommonOrganizationResponseV20241120;
export type GetOrgByIdApiArg = {
  id: string;
};
export type GetCapDetailsApiResponse =
  /** status 200 Successful Communication with GFSS  */ GmResponseCommonCapsResponse;
export type GetCapDetailsApiArg = {
  'x-bd-organization': string;
};
export type GetDocumentApiResponse =
  /** status 200 Successfully retrieved CAP Agreement PDF for document id */ string;
export type GetDocumentApiArg = {
  'x-bd-organization': string;
  documentId: string;
};
export type GetAllOrganizationsWithTypeApiResponse =
  /** status 200 OK */ GmResponseCommonListOrganizationResponseV20230717;
export type GetAllOrganizationsWithTypeApiArg = void;
export type GetOrganizationByIdWithTypeApiResponse =
  /** status 200 OK */ GmResponseCommonOrganizationResponseV20230717;
export type GetOrganizationByIdWithTypeApiArg = {
  /** The id of the organization to retrieve. */
  id: string;
};
export type GetFleetByIdV2ApiResponse =
  /** status 200 OK */ GmResponseCommonFleetConfigurationResponseV2;
export type GetFleetByIdV2ApiArg = {
  organizationId: string;
  hubId: string;
  fleetId: string;
};
export type GetAllOrganizations1ApiResponse =
  /** status 200 OK */ GmResponseCommonListOrganizationResponseV20211115;
export type GetAllOrganizations1ApiArg = void;
export type GetAllHubsApiResponse =
  /** status 200 Successfully retrieved hubs. */ GmResponseCommonListOrganizationEntityResponse;
export type GetAllHubsApiArg = {
  /** organization id for parent */
  organizationId: string;
};
export type GetHubByIdApiResponse =
  /** status 200 Successfully retrieved hub. */ GmResponseCommonOrganizationEntityResponse;
export type GetHubByIdApiArg = {
  /** organization id of hub's parent */
  organizationId: string;
  /** Hub Id */
  hubId: string;
};
export type GetAllFleets1ApiResponse =
  /** status 200 OK */ GmResponseCommonListFleetResponseDeprecated;
export type GetAllFleets1ApiArg = {
  organizationId: string;
  hubId: string;
};
export type GetFleetById1ApiResponse =
  /** status 200 OK */ GmResponseCommonFleetConfigurationResponse;
export type GetFleetById1ApiArg = {
  organizationId: string;
  hubId: string;
  fleetId: string;
};
export type GetFleetChildrenApiResponse =
  /** status 200 Successfully retrieved fleets under the hub. */ GmResponseCommonOrganizationViewJson;
export type GetFleetChildrenApiArg = {
  /** Organization ID. */
  organizationId: string;
  /** Hub ID. */
  hubId: string;
  /** Fleet ID. */
  fleetId: string;
};
export type GetHubChildrenApiResponse =
  /** status 200 Successfully retrieved hub children. */ GmResponseCommonOrganizationViewJson;
export type GetHubChildrenApiArg = {
  /** org Id for org entity */
  organizationId: string;
  /** Hub Id */
  hubId: string;
};
export type GetOrganizationChildrenApiResponse =
  /** status 200 OK */ GmResponseCommonOrganizationViewJson;
export type GetOrganizationChildrenApiArg = {
  /** The id of the organization to retrieve children for. */
  orgId: string;
};
export type GetOrganizationByIdApiResponse =
  /** status 200 OK */ GmResponseCommonOrganizationResponseV20211115;
export type GetOrganizationByIdApiArg = {
  id: string;
};
export type GetOrganizationStatsByIdApiResponse =
  /** status 200 OK */ GmResponseCommonStatsV1;
export type GetOrganizationStatsByIdApiArg = {
  id: string;
};
export type GetAllFleetsByOrganizationIdApiResponse =
  /** status 200 OK */ GmResponseCommonListFleetResponseDeprecated;
export type GetAllFleetsByOrganizationIdApiArg = {
  /** The id of the organization to retrieve fleets for. */
  id: string;
};
export type GetTopLevelOrganizationsApiResponse =
  /** status 200 OK */ GmResponseCommonListOrganizationMinViewDto;
export type GetTopLevelOrganizationsApiArg = void;
export type OrganizationPartnerIdResponse = {
  /** Unique identifier of the organization */
  organizationId?: string;
  /** Partner identifier associated with the organization, if set */
  partnerId?: string;
};
export type GmResponseError = {
  errorType: 'GENERIC' | 'VALIDATION';
  message: string;
  errorCode: string;
};
export type GmResponseCommonOrganizationPartnerIdResponse = {
  result?: OrganizationPartnerIdResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommon = {
  result?: any;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type PartnerIdUpdateRequest = {
  /** Partner identifier to associate with the organization. Null, empty, or blank clears the partner id. */
  partnerId?: string;
};
export type Address = {
  line1: string;
  line2?: string;
  city: string;
  state: string;
  postalCode: string;
  country: string;
};
export type TermsUrlsV20250211 = {
  termsAndConditions: string;
};
export type Terms = {
  /** Indicates if the terms are accepted */
  accepted?: boolean;
  /** URL of the terms document */
  url?: TermsUrlsV20250211;
  /** The date and time when the terms were accepted */
  acceptedDate?: string;
};
export type MexicoFiscalDetails = {
  /** Registro Federal de Contribuyentes. Twelve characters for a persona moral, thirteen for a persona fisica. */
  rfc: string;
  /** SAT regimen fiscal code. */
  regimenFiscal: string;
  /** Codigo postal of the registered fiscal address. Independent of the organization address. */
  fiscalZip: string;
  /** Legal name as registered with the SAT. Independent of the organization display name. */
  razonSocial: string;
};
export type PrimaryContact = {
  id?: string;
  name?: string;
};
export type AutoOnboardingConfiguration = {
  /** Whether automatic order import is enabled for this organization */
  autoImportOrdersEnabled: boolean;
  /** Whether automatic vehicle onboarding is enabled for this organization */
  autoOnboardVehiclesEnabled: boolean;
  /** Whether automatically moving vehicles to a fleet on fulfillment is enabled for this organization */
  autoMoveVehiclesToFleetEnabled: boolean;
};
export type AutoOnboardingEffectiveSettings = {
  /** Whether auto order import can run; computed, always true or false when this object is present */
  canAutoImportOrders: boolean;
  /** Whether auto vehicle onboarding can run; computed, always true or false when this object is present */
  canAutoOnboardVehicles: boolean;
  /** Whether automatically moving vehicles to a fleet on fulfillment can run; computed from organization status, verification status, FAN presence, vehicle auto-onboarding enablement, and autoMoveVehiclesToFleetEnabled */
  canAutoMoveVehiclesToFleet: boolean;
};
export type AutoOnboardingSettings = {
  /** Persisted toggles */
  configuration?: AutoOnboardingConfiguration;
  /** Effective capability flags derived from org status, verification, and configuration */
  effectiveSettings?: AutoOnboardingEffectiveSettings;
  /** Whether the auto-onboarding modal has been opened by the user. Defaults to false. */
  hasOpenedModal?: boolean;
};
export type OrganizationSettings = {
  /** Auto-onboarding configuration and effective flags */
  autoOnboarding?: AutoOnboardingSettings;
};
export type OrganizationResponseV20241120 = {
  /** Unique identifier of the organization */
  id?: string;
  /** Unique identifier of the organization */
  organizationId?: string;
  /** Name of the organization */
  name?: string;
  /** Email address of the organization */
  emailAddress?: string;
  /** Address of the organization */
  address?: Address;
  /** Creation date of the organization */
  creationDate?: string;
  /** Activation date of the organization */
  activationDate?: string;
  /** Status of the organization */
  status?: string;
  /** Terms of the organization */
  terms?: Terms;
  /** Industry of the organization */
  industry?: string;
  /** Preferred name of the organization */
  preferredName?: string;
  /** Website of the organization */
  website?: string;
  /** Fleet Account Number (FAN) of the organization */
  fan?: string;
  /** Federal tax identifier supplied at enrollment; null when the organization has none. Two digits, a hyphen, then seven digits. */
  taxId?: string;
  /** Default fleet of the organization */
  defaultFleet?: string;
  /** Country of operation of the organization; US when not set */
  countryOfOperation?: 'US' | 'MX' | 'CA';
  /** Currency of the organization's country of operation; USD when not set */
  currency?: 'USD' | 'MXN' | 'CAD';
  /** SAT fiscal identity of a Mexican organization; null outside Mexico. Returned only by the org-scoped single-organization endpoints; omitted from the system-scoped list and verification-status responses. */
  mexicoFiscalDetails?: MexicoFiscalDetails;
  /** Primary contact of the organization */
  primaryContact?: PrimaryContact;
  /** Verification status of the organization */
  verificationStatus?: 'VERIFIED' | 'PARTIALLY_VERIFIED' | 'UNVERIFIED';
  /** Reason code explaining the verification status; null when not applicable */
  verificationStatusReasonCode?:
    | 'FAN_VERIFICATION_ATTEMPTS_EXCEEDED'
    | 'ADVISOR_REVOKED'
    | 'FAN_CHANGED'
    | 'DOMAIN_MISMATCH'
    | 'FAN_NOT_FOUND'
    | 'FAN_NOT_ELIGIBLE'
    | 'FAN_VERIFICATION_INCOMPLETE'
    | 'FAN_READY_TO_LINK';
  /** Specific disqualifier note refining the reason code for the advisor UI (e.g. the GOV_FMC / PARENT_CHILD / CUSTOMER_LINKAGE variant of FAN_NOT_ELIGIBLE); null when not applicable */
  verificationStatusReasonNote?: string;
  /** Organization settings; computed effective flags are not persisted */
  settings?: OrganizationSettings;
  /** Reason the organization's enrollment is in review; null when not applicable */
  reviewReason?:
    | 'DOMAIN_MISMATCH'
    | 'FAN_DUPLICATE'
    | 'FAN_NOT_ELIGIBLE'
    | 'FAN_INACTIVE'
    | 'FAN_NOT_FOUND'
    | 'CUSTOMER_DECLINED'
    | 'NO_MATCH'
    | 'BUSINESS_MATCHING_UNAVAILABLE'
    | 'ODI_DUPLICATE'
    | 'VERIFICATION_UNAVAILABLE'
    | 'PROFILE_ALREADY_EXISTS'
    | 'ORG_ALREADY_EXISTS'
    | 'PENDING_VERIFICATION';
  /** Reason the organization is in draft status; null when not applicable */
  draftReasonCode?: 'MIGRATION';
  /** Additional details about why the organization is in draft status; null when not applicable */
  draftReasonMessage?: string;
  /** Classification of the organization for analytics and filtering; CUSTOMER when not set */
  orgType?: 'TEST' | 'DEMO' | 'DEALER' | 'CUSTOMER';
};
export type GmResponseCommonOrganizationResponseV20241120 = {
  result?: OrganizationResponseV20241120;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VerificationStatusUpdateRequest = {
  /** Target verification status */
  verificationStatus: 'VERIFIED' | 'PARTIALLY_VERIFIED' | 'UNVERIFIED';
  /** Reason code; persisted only when setting status to UNVERIFIED */
  reasonCode?:
    | 'FAN_VERIFICATION_ATTEMPTS_EXCEEDED'
    | 'ADVISOR_REVOKED'
    | 'FAN_CHANGED'
    | 'DOMAIN_MISMATCH'
    | 'FAN_NOT_FOUND'
    | 'FAN_NOT_ELIGIBLE'
    | 'FAN_VERIFICATION_INCOMPLETE'
    | 'FAN_READY_TO_LINK';
  /** Free-text note for the unverify reason */
  reasonNote?: string;
};
export type AutoOnboardingSettingsResponse = {
  /** Organization settings including auto-onboarding configuration and calculated effective flags */
  settings?: OrganizationSettings;
};
export type GmResponseCommonAutoOnboardingSettingsResponse = {
  result?: AutoOnboardingSettingsResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type AutoOnboardingSettingsUpdateRequest = {
  /** Persisted configuration of auto-onboarding toggles */
  configuration: AutoOnboardingConfiguration;
  /** Whether the auto-onboarding modal has been opened by the user. Defaults to false. */
  hasOpenedModal?: boolean;
};
export type AddressResponse = {
  line1?: string;
  line2?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
};
export type FleetResponse = {
  id?: string;
  name?: string;
  description?: string;
  phoneNumber?: string;
  emailAddress?: string;
  address?: AddressResponse;
  organizationId?: string;
  hubId?: string;
  creationDate?: string;
  timeZone?: string;
  isDefault?: boolean;
};
export type GmResponseCommonFleetResponse = {
  result?: FleetResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type FleetUpdateRequestV20250115 = {
  /** Name of the fleet */
  name: string;
  /** Notes of the fleet */
  description?: string;
  /** Contact email address of the fleet */
  emailAddress?: string;
  /** Address of the fleet */
  address?: Address;
  /** Contact phone number of the fleet */
  phoneNumber?: string;
  /** Timezone of the fleet */
  timeZone?: string;
};
export type OrganizationUpdateRequestV20241204 = {
  /** Name of the organization. */
  name: string;
  /** Address of the organization. */
  address: Address;
  /** Industry category of the organization. */
  industry?:
    | 'AGRICULTURE'
    | 'MINING'
    | 'UTILITIES'
    | 'CONSTRUCTION'
    | 'MANUFACTURING'
    | 'WHOLESALE'
    | 'RETAIL'
    | 'TRANSPORTATION'
    | 'INFORMATION'
    | 'FINANCE'
    | 'REAL_ESTATE'
    | 'PROFESSIONAL'
    | 'MANAGEMENT'
    | 'ADMINISTRATIVE'
    | 'EDUCATIONAL'
    | 'HEALTH'
    | 'ARTS'
    | 'FOOD'
    | 'OTHER'
    | 'PUBLIC';
  /** Primary Contact for the organization. */
  primaryContact?: PrimaryContact;
  /** Fan of organization */
  fan?: string;
  /** Preferred Name of the organization. */
  preferredName?: string;
  /** Website of the organization. */
  website?: string;
  /** SAT fiscal identity, for Mexican organizations only. Changing it requires the Organization.ModifyProtectedValues permission. Omit to leave unchanged. */
  mexicoFiscalDetails?: MexicoFiscalDetails;
  /** Federal tax identifier of the organization. Two digits, a hyphen, then seven digits. Changing it requires the Organization.ModifyProtectedValues permission, and is rejected when another organization already holds it. Omit to leave unchanged. */
  taxId?: string;
  /** Classification of the organization for analytics and filtering. Changing it requires the system-level Organization.Enrollment.Update permission. Omit to leave unchanged. */
  orgType?: 'TEST' | 'DEMO' | 'DEALER' | 'CUSTOMER';
};
export type OrganizationResponseV20230717 = {
  id?: string;
  name: string;
  emailAddress: string;
  address: Address;
  creationDate?: string;
  activationDate?: string;
  status?: string;
  phoneNumber: string;
  primaryContact?: PrimaryContact;
  type?: string;
  orgMasterNumber?: string;
  /** Country of operation of the organization */
  countryOfOperation?: 'US' | 'MX' | 'CA';
};
export type GmResponseCommonOrganizationResponseV20230717 = {
  result?: OrganizationResponseV20230717;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type UserPreferences = {
  locale?: string;
};
export type LevelDto = {
  name?: string;
};
export type OrganizationUpdateRequest = {
  /** Organization name */
  name: string;
  /** Email address */
  emailAddress: string;
  /** User preferences */
  userPreferences?: UserPreferences;
  /** Address */
  address: Address;
  /** Phone number */
  phoneNumber: string;
  /** Primary contact for the organization */
  primaryContact?: PrimaryContact;
  /** Hierarchy levels for organization */
  levels?: {
    [key: string]: LevelDto;
  };
  level?: number;
  /** Organization master number. Should be a 10-digit number that does not start with zero */
  orgMasterNumber?: string;
  /** SAT fiscal identity, for Mexican organizations only. Changing it requires the Organization.ModifyProtectedValues permission. Omit to leave unchanged. */
  mexicoFiscalDetails?: MexicoFiscalDetails;
};
export type HierarchyObjectView = {
  id?: string;
  name?: string;
};
export type Value = {
  autolockEnabled?: boolean;
  autolockTimeout?: number;
  proximityUnlockEnabled?: boolean;
  timeZone?: string;
  audioVolumeLimit?: number;
  audioVolumeLimitEnabled?: boolean;
  speedWarningThreshold?: number;
  speedWarningEnabled?: boolean;
  buckleToDriveEnabled?: boolean;
  supervisedDriveModeEnabled?: boolean;
  chargingScheduleEnabled?: boolean;
  chargingScheduleTargetChargeLevel?: number;
  chargingScheduleDepartureTime?: string;
  homeLocationLatitude?: number;
  homeLocationLongitude?: number;
};
export type ConfigurationValueDto = {
  lastUpdated?: string;
  value?: Value;
};
export type FleetConfigurationResponse = {
  id?: string;
  name?: string;
  description?: string;
  organization?: HierarchyObjectView;
  hub?: HierarchyObjectView;
  creationDate?: string;
  configuration?: ConfigurationValueDto;
};
export type GmResponseCommonFleetConfigurationResponse = {
  result?: FleetConfigurationResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ConfigurationRequest = {
  /** Flag to set if asset automatically locks itself. */
  autolockEnabled: boolean;
  /** Threshold time before this asset locks when autolock is enabled. */
  autolockTimeout?: number;
  /** Lock/unlock's asset if within an area near to it. */
  proximityUnlockEnabled: boolean;
  /** Enables to set maximum audio limit. */
  audioVolumeLimitEnabled?: boolean;
  /** Sets maximum audio limit of audio limit is enabled. Minimum is 0. */
  audioVolumeLimit?: number;
  /** Enables asset's safety setting feature. */
  supervisedDriveModeEnabled?: boolean;
  /** Sets the maximum speed of an asset when enabled. */
  speedWarningEnabled?: boolean;
  /**   Maximum speed an asset can go if speedWarningEnabled is true.
      Should be between 0 and 161.
     */
  speedWarningThreshold?: number;
  /**   Notifies automatically the driver to buckle-on before driving
      but is dependent to supervisedDriveModeEnabled to be enabled.
     */
  buckleToDriveEnabled?: boolean;
  /** Whether charging schedule is enabled for this fleet. */
  chargingScheduleEnabled?: boolean;
  /** The target soc level for it to be considered charged. */
  chargingScheduleTargetChargeLevel?: number;
  /**   The time the assets in this fleet should be ready by this time of the day.
      Time should be in 24-hour format with 15-minute increments and seconds are in 0 value
     */
  chargingScheduleDepartureTime?: string;
  /** Latitude of this fleet's home location. */
  homeLocationLatitude?: number;
  /** Longitude of this fleet's home location. */
  homeLocationLongitude?: number;
  /** Timezone this fleet is in. */
  timeZone?: string;
};
export type OrganizationEntityConfigurationDto = {
  safeRefrigeratedGroceryThreshold?: number;
  safeFrozenGroceryThreshold?: number;
  chargingScheduleHomeLocationDisplayAddress?: string;
};
export type FleetUpdateRequest = {
  name?: string;
  hubId: string;
  description?: string;
  configuration?: ConfigurationRequest;
  organizationEntityConfiguration?: OrganizationEntityConfigurationDto;
};
export type SyncOviTrialSubscriptionResponse = {
  /** CSP organization ID. */
  cspOrganizationId?: string;
  /** OVI business account ID. */
  oviAccountId?: string;
  /** Change operation performed. */
  changeOp?: 'created' | 'updated' | 'retired' | 'skipped' | 'no-change';
};
export type GmResponseCommonSyncOviTrialSubscriptionResponse = {
  result?: SyncOviTrialSubscriptionResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type SyncOviTrialSubscriptionRequest = {
  /** HVR change operation indicator. */
  hvrChangeOp: '0' | '1' | '2';
  /** HVR change sequence identifier. */
  hvrChangeSequence: string;
  /** HVR change timestamp. */
  hvrChangeTime: string;
  /** OVI business account ID. */
  oviAccountId: string;
  /** Corresponding CSP organization ID. */
  cspOrganizationId: string;
  /** OVI trial subscription start date. Stored as the organization's creationDate. */
  startDate: string;
  /** OVI product type. Must be ovi.service. */
  productType: string;
  /** OVI price plan. Must be trial. */
  pricePlan: string;
  /** OVI subscription status code. */
  statusCode: 'active' | 'inactive' | 'retired';
};
export type ValidationError = {
  /** Validation error code. */
  code?: 'NOT_FOUND' | 'INVALID_STATE' | 'INVALID_FIELD';
  /** Field that failed validation. */
  field?: string;
  /** Validation error message. */
  message?: string;
};
export type ValidateMigratedOviTrialStartDateResponse = {
  /** True when all validation checks pass. */
  valid?: boolean;
  /** OVI business account ID. */
  oviAccountId?: string;
  /** CSP organization ID. Present when validation passes. */
  cspOrganizationId?: string;
  /** Validation error details when valid is false. */
  error?: ValidationError;
};
export type GmResponseCommonValidateMigratedOviTrialStartDateResponse = {
  result?: ValidateMigratedOviTrialStartDateResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ValidateMigratedOviTrialStartDateRequest = {
  /** OVI business account ID. */
  oviAccountId: string;
  /** Corresponding CSP organization ID. */
  cspOrganizationId: string;
  /** OVI trial subscription start date. Compared to the organization's creationDate. */
  startDate: string;
  /** OVI product type. Must be ovi.service. */
  productType: string;
  /** OVI price plan. Must be trial. */
  pricePlan: string;
  /** OVI subscription status code. */
  statusCode: 'active' | 'inactive' | 'retired';
};
export type CloseAcceptedResponse = {
  /** Unique identifier of the organization */
  organizationId: string;
  /** Organization lifecycle status */
  status: string;
  /** Coarse Close Organization summary; null before the first worker message sets a public value */
  closingStatus?: string;
  /** Timestamp of the latest closingStatus change */
  closingStatusDate?: string;
  /** Machine-readable failure code when closingStatus is FAILED */
  closingFailedCode?: string;
  /** Human-readable failure detail when closingStatus is FAILED */
  closingFailedMessage?: string;
};
export type GmResponseCommonCloseAcceptedResponse = {
  result?: CloseAcceptedResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type CloseOrgReconciliationOutcome = {
  candidates?: number;
  repaired?: number;
};
export type GmResponseCommonCloseOrgReconciliationOutcome = {
  result?: CloseOrgReconciliationOutcome;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VerifyFanResponse = {
  /** Organization id. */
  organizationId?: string;
  /** Verified Fleet Account Number (success only). */
  fan?: string;
  /** Verification status after the operation (success only). */
  verificationStatus?: 'VERIFIED' | 'PARTIALLY_VERIFIED' | 'UNVERIFIED';
  /** Reason verification was rejected (409 conflict only). */
  reviewReason?:
    | 'DOMAIN_MISMATCH'
    | 'FAN_DUPLICATE'
    | 'FAN_NOT_ELIGIBLE'
    | 'FAN_INACTIVE'
    | 'FAN_NOT_FOUND'
    | 'CUSTOMER_DECLINED'
    | 'NO_MATCH'
    | 'BUSINESS_MATCHING_UNAVAILABLE'
    | 'ODI_DUPLICATE'
    | 'VERIFICATION_UNAVAILABLE'
    | 'PROFILE_ALREADY_EXISTS'
    | 'ORG_ALREADY_EXISTS'
    | 'PENDING_VERIFICATION';
};
export type GmResponseCommonVerifyFanResponse = {
  result?: VerifyFanResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VerifyFanRequest = {
  /** Fleet Account Number (6 alphanumeric characters). */
  fan: string;
};
export type ValidateMigratedOviFleetsResponseEntry = {
  /** True when all fleet entry validation checks pass. */
  valid?: boolean;
  /** Validation error details when valid is false. */
  error?: ValidationError;
  /** OVI fleet ID. */
  oviFleetId?: string;
  /** CSP fleet ID. */
  cspFleetId?: string;
};
export type ValidateMigratedOviFleetsResponse = {
  /** OVI business account ID. */
  oviAccountId?: string;
  /** CSP organization ID. */
  cspOrganizationId?: string;
  /** True when every request fleet entry has a matching CSP fleet by OVI fleet ID. */
  allOviFleetIdsMatched?: boolean;
  /** True when every CSP fleet (excluding Unassigned Fleet) has a matching request entry. */
  allCspFleetIdsMatched?: boolean;
  /** Per-fleet validation results. */
  fleets?: ValidateMigratedOviFleetsResponseEntry[];
};
export type GmResponseCommonValidateMigratedOviFleetsResponse = {
  result?: ValidateMigratedOviFleetsResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OviAddress = {
  /** HVR change operation indicator. */
  hvrChangeOp: '0' | '1' | '2';
  /** HVR change sequence identifier. */
  hvrChangeSequence: string;
  /** HVR change timestamp. */
  hvrChangeTime: string;
  /** Type of address. */
  addressType: 'billing' | 'home' | 'work';
  /** Country code. */
  countryCode: string;
  /** State code. */
  stateCode: string;
  /** City name. */
  city: string;
  /** Street name. May be blank for OVI migration records. */
  street?: string;
  /** House number. May be blank for OVI migration records. */
  house?: string;
  /** ZIP code. */
  zipCode: string;
  /** Post box number. */
  postBox?: string;
  /** District name. */
  district?: string;
};
export type OviContact = {
  /** HVR change operation indicator. */
  hvrChangeOp: '0' | '1' | '2';
  /** HVR change sequence identifier. */
  hvrChangeSequence: string;
  /** HVR change timestamp. */
  hvrChangeTime: string;
  /** Type of contact. */
  contactType: 'email' | 'phone';
  /** Contact label aka email address or phone number. */
  contactLabel: string;
  /** Contact description. */
  contactDescription?: string;
};
export type ValidateMigratedOviFleetsRequestEntry = {
  /** OVI fleet account ID. */
  fleetId: string;
  /** OVI fleet account name. */
  accountName: string;
  /** OVI fleet account status code. */
  statusCode: 'active' | 'inactive' | 'retired';
  /** Fleet description. */
  description?: string;
  /** List of OVI addresses. */
  addresses: OviAddress[];
  /** List of OVI contacts. May be empty when OVI holds no contact for the record. */
  contacts: OviContact[];
};
export type ValidateMigratedOviFleetsRequest = {
  /** OVI business account ID. */
  oviAccountId: string;
  /** CSP organization ID. */
  cspOrganizationId: string;
  /** List of OVI fleet entries to validate. */
  fleets: ValidateMigratedOviFleetsRequestEntry[];
};
export type ValidateMigratedOviBusinessAccountResponse = {
  /** True when all validation checks pass. */
  valid?: boolean;
  /** OVI business account ID. */
  oviAccountId?: string;
  /** Validation error details when valid is false. */
  error?: ValidationError;
};
export type GmResponseCommonValidateMigratedOviBusinessAccountResponse = {
  result?: ValidateMigratedOviBusinessAccountResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ValidateMigratedOviBusinessAccountRequest = {
  /** OVI business account ID. */
  oviAccountId: string;
  /** CSP organization ID. */
  cspOrganizationId: string;
  /** OVI account name. */
  accountName: string;
  /** List of FAN identifiers. */
  fans?: string[];
  /** List of OVI addresses. */
  addresses: OviAddress[];
  /** List of OVI contacts. May be empty when OVI holds no contact for the record. */
  contacts: OviContact[];
};
export type EnrollmentSubmissionResponse = {
  organizationId?: string;
  status?: 'REVIEW' | 'APPROVED' | 'DECLINED';
  reviewReason?:
    | 'DOMAIN_MISMATCH'
    | 'FAN_DUPLICATE'
    | 'FAN_NOT_ELIGIBLE'
    | 'FAN_INACTIVE'
    | 'FAN_NOT_FOUND'
    | 'CUSTOMER_DECLINED'
    | 'NO_MATCH'
    | 'BUSINESS_MATCHING_UNAVAILABLE'
    | 'ODI_DUPLICATE'
    | 'VERIFICATION_UNAVAILABLE'
    | 'PROFILE_ALREADY_EXISTS'
    | 'ORG_ALREADY_EXISTS'
    | 'PENDING_VERIFICATION';
};
export type GmResponseCommonEnrollmentSubmissionResponse = {
  result?: EnrollmentSubmissionResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type EnrollmentUnifiedLookupRequest = {
  /** Flow 1: Fleet Account Number (6 alphanumeric characters). Mutually exclusive with name/address. */
  fan?: string;
  /** Flow 2: Organization name. Required when not using 'fan'. */
  name?: string;
  /** Flow 2: Structured postal address for the organization. Provide this OR 'rawAddress', but not both. */
  address?: Address;
  /** Flow 2: Free-text address (e.g. "730 Jackline Drive, West Eltonville, VT 41052"). Resolved to a structured address via ODI cspMatchRawAddress before downstream matching. Provide this OR 'address', not both. */
  rawAddress?: string;
  /** Advisor-assisted LOOKUP (Flow 1 FAN and Flow 2 name+address): optional org primary-contact email whose domain drives the D&B domain check instead of the caller's auth-token email. The advisor supplies the org's primary-contact email so the domain gate evaluates the business domain rather than the advisor's. PERMISSION-GATED: honored ONLY for callers holding the 'Organization.Enrollment.Update' (advisor) permission; for all other callers it is ignored and the caller's auth-token email domain is used. Also ignored when absent or malformed and for the submit endpoint (submit always uses the caller's token email domain). */
  orgPrimaryContactEmail?: string;
  /** Market the organization operates in. Defaults to US when omitted. */
  countryOfOperation?: 'US' | 'MX' | 'CA';
  /** Advisor LOOKUP only: id of the org the advisor is viewing. When supplied by an advisor (Organization.Enrollment.Update), the D&B/MuleSoft records this lookup considered are persisted (store-only, redacted) onto that org for reporting. Ignored for non-advisor callers and for the submit endpoint. */
  organizationId?: string;
  /** Federal tax identifier to persist on the organization. Two digits, a hyphen, then seven digits. On submit, a tax id already held by a pending or active organization is rejected. Lookup accepts the field for request-shape parity with submit but ignores it, since lookup creates no organization to collide with. */
  taxId?: string;
};
export type EnrollmentSubmitRequest = {
  /** Opaque candidate reference returned by /enrollment/lookup to confirm the candidate. */
  candidateRef?: string;
  /** Original lookup request used to retrieve the candidate. */
  lookupRequest: EnrollmentUnifiedLookupRequest;
  /** When candidateRef is null: true if the customer declined candidates, false if there were no candidates. Optional for backward compatibility — omit to leave unset. */
  customerDeclined?: boolean;
  /** SAT fiscal identity. Required when countryOfOperation is MX, rejected otherwise. */
  mexicoFiscalDetails?: MexicoFiscalDetails;
};
export type ParentDto = {
  levelId?: number;
  parentId?: string;
};
export type OrganizationEntityDto = {
  organizationId?: string;
  organization?: HierarchyObjectView;
  parents?: ParentDto[];
  childStats?: {
    [key: string]: number;
  };
  level?: number;
  name: string;
  description?: string;
  address?: Address;
  phoneNumber?: string;
  emailAddress?: string;
  capFan?: number;
  creationDate?: string;
  createdBy?: string;
  updateDate?: string;
  updatedBy?: string;
  configurationValue?: ConfigurationValueDto;
  organizationEntityConfiguration?: OrganizationEntityConfigurationDto;
  status?: 'ACTIVE' | 'RETIRED' | 'CLOSING' | 'CLOSED';
  oviFleetId?: string;
  oviAccountId?: string;
  oviChangeSequence?: string;
  id?: string;
};
export type GmPageOrganizationEntityDto = {
  items: OrganizationEntityDto[];
  total_items?: number;
  continuation_token?: string;
};
export type GmResponseCommonGmPageOrganizationEntityDto = {
  result?: GmPageOrganizationEntityDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ErrorDetail = {
  /** Error code. */
  errorCode?: string;
  /** Error message. */
  errorMessage?: string;
};
export type SyncOviFleetResponseEntry = {
  /** True if operation succeeded, false otherwise. */
  success?: boolean;
  /** Error details if operation failed, null otherwise. */
  error?: ErrorDetail;
  /** Assigned CSP fleet ID. */
  fleetId?: string;
  /** OVI fleet account ID. */
  accountId?: string;
  /** Change operation performed. */
  changeOp?: 'created' | 'updated' | 'retired' | 'skipped' | 'no-change';
};
export type SyncOviFleetResponse = {
  /** List of fleet sync results. */
  fleets?: SyncOviFleetResponseEntry[];
};
export type GmResponseCommonSyncOviFleetResponse = {
  result?: SyncOviFleetResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type SyncOviFleetRequestEntry = {
  /** HVR change operation indicator. */
  hvrChangeOp: '0' | '1' | '2';
  /** HVR change sequence identifier. */
  hvrChangeSequence: string;
  /** HVR change timestamp. */
  hvrChangeTime: string;
  /** OVI fleet account ID. */
  accountId: string;
  /** OVI fleet account name. */
  accountName: string;
  /** OVI fleet account status code. */
  statusCode: 'active' | 'inactive' | 'retired';
  /** Fleet description. */
  description?: string;
  /** Fleet timezone. */
  timezone?: string;
  /** List of OVI addresses. */
  addresses: OviAddress[];
  /** List of OVI contacts. May be empty when OVI holds no contact for the record. */
  contacts: OviContact[];
};
export type SyncOviFleetRequest = {
  /** OVI business account ID. */
  oviAccountId: string;
  /** CSP organization ID. */
  cspOrganizationId: string;
  /** List of fleet accounts to sync. */
  fleets: SyncOviFleetRequestEntry[];
};
export type ActivateOrganizationResponse = {
  /** Whether the organization was successfully activated. */
  activated?: boolean;
};
export type GmResponseCommonActivateOrganizationResponse = {
  result?: ActivateOrganizationResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ActivateOrganizationRequest = {
  /** OVI business account ID. */
  oviAccountId: string;
  /** Corresponding CSP organization ID. */
  cspOrganizationId: string;
};
export type EnrollmentCandidate = {
  /** Opaque reference for submit (e.g. fan:123456). */
  candidateRef?: string;
  /** Business name from the fleet account lookup. */
  name?: string;
  /** Business address from the fleet account lookup. */
  address?: Address;
  /** Fleet Account Number. */
  fan?: string;
  /** Business phone number. */
  phoneNumber?: string;
  /** Business website. */
  website?: string;
  /** Industry classification. */
  industry?: string;
};
export type EnrollmentLookupResponse = {
  enrollmentCandidates?: EnrollmentCandidate[];
  reviewReason?:
    | 'DOMAIN_MISMATCH'
    | 'FAN_DUPLICATE'
    | 'FAN_NOT_ELIGIBLE'
    | 'FAN_INACTIVE'
    | 'FAN_NOT_FOUND'
    | 'CUSTOMER_DECLINED'
    | 'NO_MATCH'
    | 'BUSINESS_MATCHING_UNAVAILABLE'
    | 'ODI_DUPLICATE'
    | 'VERIFICATION_UNAVAILABLE'
    | 'PROFILE_ALREADY_EXISTS'
    | 'ORG_ALREADY_EXISTS'
    | 'PENDING_VERIFICATION';
  organizationId?: string;
};
export type GmResponseCommonEnrollmentLookupResponse = {
  result?: EnrollmentLookupResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type SyncOviBusinessAccountResponse = {
  /** CSP organization ID. */
  organizationId?: string;
  /** OVI business account ID. */
  accountId?: string;
  /** Change operation performed. */
  changeOp?: 'created' | 'updated' | 'retired' | 'skipped' | 'no-change';
};
export type GmResponseCommonSyncOviBusinessAccountResponse = {
  result?: SyncOviBusinessAccountResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type SyncOviBusinessAccountRequest = {
  /** HVR change operation indicator. */
  hvrChangeOp: '0' | '1' | '2';
  /** HVR change sequence identifier. */
  hvrChangeSequence: string;
  /** HVR change timestamp. */
  hvrChangeTime: string;
  /** OVI account ID. */
  accountId: string;
  /** OVI account name. */
  accountName: string;
  /** OVI account status code. */
  statusCode: 'active' | 'inactive' | 'retired';
  /** List of FAN identifiers. */
  fans?: string[];
  /** List of OVI addresses. */
  addresses: OviAddress[];
  /** List of OVI contacts. May be empty when OVI holds no contact for the record. */
  contacts: OviContact[];
  /** Market the account operates in. Falls back to the work address country code, then US. */
  countryOfOperation?: 'US' | 'MX' | 'CA';
  /** Creation date sourced from the OVI account's _created_on field. When provided, this value is stored as the org's creationDate; defaults to 2026-01-01 if absent, to avoid inadvertently triggering CSP trial license creation. */
  createdOn?: string;
};
export type FleetView = {
  id?: string;
  name?: string;
};
export type OrganizationView = {
  id?: string;
  name?: string;
  defaultFleetId?: string;
  fleets?: {
    [key: string]: FleetView;
  };
};
export type OrganizationViewResponseV20260113 = {
  organizations?: {
    [key: string]: OrganizationView;
  };
};
export type GmResponseCommonOrganizationViewResponseV20260113 = {
  result?: OrganizationViewResponseV20260113;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OrganizationViewRequest = {
  /** Organization Ids to view data for */
  organizationIds?: string[];
};
export type CspCandidate = {
  name: string;
  address: Address;
  odiRef: string;
  phoneNumber?: string;
  website?: string;
  industry?: string;
};
export type GmResponseCommonCspCandidate = {
  result?: CspCandidate;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OrganizationLookupRequest = {
  /** Name of the organization. */
  name: string;
  /** Structured postal address of the organization. */
  address: Address;
  /** Market the organization operates in. Defaults to US when omitted. */
  countryOfOperation?: 'US' | 'MX' | 'CA';
};
export type OrganizationLookupRawAddressResponse = {
  /** Structured postal address returned by ODI after parsing and resolving the raw search string; present whenever ODI supplied resolved coordinates or normalized address components. */
  resolvedAddress?: Address;
  /** CSP match candidate when ODI produced a definitive CSP organization match; null when no such match exists. */
  candidate?: CspCandidate;
};
export type GmResponseCommonOrganizationLookupRawAddressResponse = {
  result?: OrganizationLookupRawAddressResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OrganizationLookupRequestRawAddress = {
  /** Name of the organization. */
  name: string;
  /** Free-form address text passed to ODI for parsing, geocoding, and CSP matching (e.g. street, city, region, postal code). */
  rawAddressSearchString: string;
  /** Market the organization operates in. Defaults to US when omitted. */
  countryOfOperation?: 'US' | 'MX' | 'CA';
};
export type OdiMatchConfirmation = {
  /** Structured name and address from the customer's enrollment input.
    After '/lookup-raw-address', rebuild this object using the resolved structured address from that response together with the confirmed organization name. */
  originalRequest: OrganizationLookupRequest;
  /** The `odiRef` from the CSP candidate (HTTP 200 responses from '/lookup' or '/lookup-raw-address'). */
  odiRef: string;
  /** SAT fiscal identity. Required when countryOfOperation is MX, rejected otherwise. */
  mexicoFiscalDetails?: MexicoFiscalDetails;
};
export type EnrollNoMatchRequest = {
  /** Data from the original user input (structured address fields).
    If enrollment began with '/lookup-raw-address', compose this object using the resolved address from that step. */
  originalRequest: OrganizationLookupRequest;
  /** The `odiRef` value from a successful '/lookup' response or from `candidate.odiRef` after '/lookup-raw-address'. */
  odiRef?: string;
  /** SAT fiscal identity. Required when countryOfOperation is MX, rejected otherwise. */
  mexicoFiscalDetails?: MexicoFiscalDetails;
};
export type TermsResponseV20250211 = {
  organizationId?: string;
  terms?: Terms;
};
export type GmResponseCommonTermsResponseV20250211 = {
  result?: TermsResponseV20250211;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type TermsRequestV20250211 = {
  /** URL of the terms document */
  urls: TermsUrlsV20250211;
  /** If the terms are accepted */
  accepted?: boolean;
};
export type EnrollmentRequest = {
  /** Name of the organization. */
  name: string;
  /** Industry category of the organization. */
  industry:
    | 'AGRICULTURE'
    | 'MINING'
    | 'UTILITIES'
    | 'CONSTRUCTION'
    | 'MANUFACTURING'
    | 'WHOLESALE'
    | 'RETAIL'
    | 'TRANSPORTATION'
    | 'INFORMATION'
    | 'FINANCE'
    | 'REAL_ESTATE'
    | 'PROFESSIONAL'
    | 'MANAGEMENT'
    | 'ADMINISTRATIVE'
    | 'EDUCATIONAL'
    | 'HEALTH'
    | 'ARTS'
    | 'FOOD'
    | 'OTHER'
    | 'PUBLIC';
  /** Address of the organization. */
  address: Address;
  /** Preferred Name of the organization. */
  preferredName?: string;
  /** Website of the organization. */
  website?: string;
};
export type GmResponseCommonVoid = {
  result?: any;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type EnrollmentDeclineRequest = {
  /** Reason for decline the enrollment. */
  reasonNote: string;
  /** Reason code for decline the enrollment */
  reasonCode: 'NOT_QUALIFIED' | 'OTHER';
};
export type AdminEnrollmentRequest = {
  /** Name of the organization. */
  name: string;
  /** On behalf of email address, represents primary email of the org. */
  onBehalfOfEmail: string;
  /** Address of the organization. */
  address: Address;
  /** Fan of organization */
  fan?: string;
  /** Federal tax identifier to persist on the organization. Two digits, a hyphen, then seven digits. A tax id already held by a pending, enrolling, or active organization is rejected. */
  taxId?: string;
  /** Industry category of the organization. */
  industry:
    | 'AGRICULTURE'
    | 'MINING'
    | 'UTILITIES'
    | 'CONSTRUCTION'
    | 'MANUFACTURING'
    | 'WHOLESALE'
    | 'RETAIL'
    | 'TRANSPORTATION'
    | 'INFORMATION'
    | 'FINANCE'
    | 'REAL_ESTATE'
    | 'PROFESSIONAL'
    | 'MANAGEMENT'
    | 'ADMINISTRATIVE'
    | 'EDUCATIONAL'
    | 'HEALTH'
    | 'ARTS'
    | 'FOOD'
    | 'OTHER'
    | 'PUBLIC';
  /** Preferred Name of the organization. */
  preferredName?: string;
  /** Website of the organization. */
  website?: string;
  /** Partner identifier associated with the organization. */
  partnerId?: string;
  /** Market the organization operates in. Defaults to US when omitted. */
  countryOfOperation?: 'US' | 'MX' | 'CA';
  /** SAT fiscal identity. Required when countryOfOperation is MX, rejected otherwise. */
  mexicoFiscalDetails?: MexicoFiscalDetails;
  /** Classification of the organization for analytics and filtering. Defaults to CUSTOMER when omitted. */
  orgType?: 'TEST' | 'DEMO' | 'DEALER' | 'CUSTOMER';
};
export type UpdateDefaultFleetRequest = {
  /** The ID of the fleet to set as the default fleet. */
  defaultFleetId: string;
};
export type FleetCreateResponse = {
  id?: string;
  name?: string;
  description?: string;
  phoneNumber?: string;
  emailAddress?: string;
  address?: AddressResponse;
  organization?: HierarchyObjectView;
  hub?: HierarchyObjectView;
  creationDate?: string;
  timeZone?: string;
};
export type GmResponseCommonFleetCreateResponse = {
  result?: FleetCreateResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type FleetCreateRequestV20240926 = {
  /** Name of the fleet */
  name: string;
  /** Notes of the fleet */
  description?: string;
  /** Contact email address of the fleet */
  emailAddress?: string;
  /** Address of the fleet */
  address?: Address;
  /** Contact phone number of the fleet */
  phoneNumber?: string;
  /** Timezone of the fleet */
  timeZone?: string;
};
export type ConfigChangeCheckRequest = {
  lastUpdated?: string;
};
export type EntityViewJson = {
  id?: string;
  name?: string;
};
export type HubViewJson = {
  id?: string;
  name?: string;
  fleets?: {
    [key: string]: EntityViewJson;
  };
};
export type OrganizationViewJson = {
  id?: string;
  name?: string;
  defaultFleetId?: string;
  hubs?: {
    [key: string]: HubViewJson;
  };
};
export type OrganizationsViewResponse = {
  organizations?: {
    [key: string]: OrganizationViewJson;
  };
};
export type GmResponseCommonOrganizationsViewResponse = {
  result?: OrganizationsViewResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type CloseUserProgress = {
  status:
    | 'NOT_STARTED'
    | 'PENDING'
    | 'IN_PROGRESS'
    | 'COMPLETED'
    | 'FAILED'
    | 'UNAVAILABLE';
  jobId?: string;
  total?: number;
  completed?: number;
  failed?: number;
};
export type CloseVehicleProgress = {
  status:
    | 'NOT_STARTED'
    | 'PENDING'
    | 'IN_PROGRESS'
    | 'COMPLETED'
    | 'FAILED'
    | 'UNAVAILABLE';
  batchIds: string[];
  total?: number;
  completed?: number;
  failed?: number;
};
export type CloseStatusResponse = {
  /** Unique identifier of the organization */
  organizationId: string;
  /** Organization lifecycle status */
  status: string;
  /** Coarse Close Organization summary; null before the first worker message sets a public value */
  closingStatus?: string;
  /** Timestamp of the latest closingStatus change */
  closingStatusDate?: string;
  /** Machine-readable failure code when closingStatus is FAILED */
  closingFailedCode?: string;
  /** Human-readable failure detail when closingStatus is FAILED */
  closingFailedMessage?: string;
  /** Live user off-board progress */
  users: CloseUserProgress;
  /** Live vehicle off-board progress */
  vehicles: CloseVehicleProgress;
};
export type GmResponseCommonCloseStatusResponse = {
  result?: CloseStatusResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type EnrollmentStatusResponse = {
  existingEnrollment?: boolean;
  organizationId?: string;
  organizationStatus?:
    | 'DRAFT'
    | 'PENDING'
    | 'ENROLLING'
    | 'ACTIVE'
    | 'DISABLED'
    | 'DELETED'
    | 'ABORTED'
    | 'RETIRED'
    | 'CLOSING'
    | 'CLOSED';
  verificationStatus?: 'VERIFIED' | 'PARTIALLY_VERIFIED' | 'UNVERIFIED';
  enrollmentStatus?: 'REVIEW' | 'APPROVED' | 'DECLINED';
  reviewReason?:
    | 'DOMAIN_MISMATCH'
    | 'FAN_DUPLICATE'
    | 'FAN_NOT_ELIGIBLE'
    | 'FAN_INACTIVE'
    | 'FAN_NOT_FOUND'
    | 'CUSTOMER_DECLINED'
    | 'NO_MATCH'
    | 'BUSINESS_MATCHING_UNAVAILABLE'
    | 'ODI_DUPLICATE'
    | 'VERIFICATION_UNAVAILABLE'
    | 'PROFILE_ALREADY_EXISTS'
    | 'ORG_ALREADY_EXISTS'
    | 'PENDING_VERIFICATION';
};
export type GmResponseCommonEnrollmentStatusResponse = {
  result?: EnrollmentStatusResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type HierarchyObjectViewDto = {
  id?: string;
  name?: string;
};
export type LegalDocumentDto = {
  url?: string;
  accepted?: boolean;
  acceptedDate?: string;
};
export type LegalDto = {
  termsAndConditions?: LegalDocumentDto;
  privacyPolicy?: LegalDocumentDto;
};
export type EnrollmentDto = {
  status?: 'REVIEW' | 'APPROVED' | 'DECLINED';
  submittedDate?: string;
  submittedAccountType?: 'CUSTOMER' | 'ADVISOR' | 'NONE';
  submittedOnBehalfOfEmail?: string;
  approvedDate?: string;
  approvedApproach?: 'AUTO' | 'MANUAL';
  approvedBy?: string;
  declinedDate?: string;
  declinedBy?: string;
  declinedNote?: string;
  declineReasonCode?: 'NOT_QUALIFIED' | 'OTHER';
  reviewReason?:
    | 'DOMAIN_MISMATCH'
    | 'FAN_DUPLICATE'
    | 'FAN_NOT_ELIGIBLE'
    | 'FAN_INACTIVE'
    | 'FAN_NOT_FOUND'
    | 'CUSTOMER_DECLINED'
    | 'NO_MATCH'
    | 'BUSINESS_MATCHING_UNAVAILABLE'
    | 'ODI_DUPLICATE'
    | 'VERIFICATION_UNAVAILABLE'
    | 'PROFILE_ALREADY_EXISTS'
    | 'ORG_ALREADY_EXISTS'
    | 'PENDING_VERIFICATION';
};
export type AutoOnboardingConfigurationDto = {
  autoImportOrdersEnabled?: boolean;
  autoOnboardVehiclesEnabled?: boolean;
  autoMoveVehiclesToFleetEnabled?: boolean;
  hasOpenedModal?: boolean;
};
export type AutoOnboardingDto = {
  configuration?: AutoOnboardingConfigurationDto;
};
export type OrganizationSettingsDto = {
  autoOnboarding?: AutoOnboardingDto;
};
export type OrganizationDto = {
  id?: string;
  organizationId?: string;
  odiId?: string;
  partnerId?: string;
  name?: string;
  primaryEmailAddress?: string;
  address?: Address;
  creationDate?: string;
  createdBy?: string;
  updateDate?: string;
  updatedBy?: string;
  activationDate?: string;
  activatedBy?: string;
  status?:
    | 'DRAFT'
    | 'PENDING'
    | 'ENROLLING'
    | 'ACTIVE'
    | 'DISABLED'
    | 'DELETED'
    | 'ABORTED'
    | 'RETIRED'
    | 'CLOSING'
    | 'CLOSED';
  closedBy?: string;
  closedDate?: string;
  closingStatus?: 'PENDING' | 'FAILED' | 'COMPLETED';
  closingStatusDate?: string;
  closingFailedCode?: string;
  closingFailedMessage?: string;
  phoneNumber?: string;
  primaryContact?: HierarchyObjectViewDto;
  legal?: LegalDto;
  levels?: {
    [key: string]: LevelDto;
  };
  childStats?: {
    [key: string]: number;
  };
  level?: number;
  type?: 'ASSET' | 'SERVICE' | 'GMF';
  orgMasterNumber?: string;
  enrollment?: EnrollmentDto;
  preferredName?: string;
  industry?:
    | 'AGRICULTURE'
    | 'MINING'
    | 'UTILITIES'
    | 'CONSTRUCTION'
    | 'MANUFACTURING'
    | 'WHOLESALE'
    | 'RETAIL'
    | 'TRANSPORTATION'
    | 'INFORMATION'
    | 'FINANCE'
    | 'REAL_ESTATE'
    | 'PROFESSIONAL'
    | 'MANAGEMENT'
    | 'ADMINISTRATIVE'
    | 'EDUCATIONAL'
    | 'HEALTH'
    | 'ARTS'
    | 'FOOD'
    | 'OTHER'
    | 'PUBLIC';
  website?: string;
  fan?: string;
  defaultFleet?: string;
  /** Country of operation of the organization */
  countryOfOperation?: 'US' | 'MX' | 'CA';
  verificationStatus?: 'VERIFIED' | 'PARTIALLY_VERIFIED' | 'UNVERIFIED';
  verificationStatusReasonCode?:
    | 'FAN_VERIFICATION_ATTEMPTS_EXCEEDED'
    | 'ADVISOR_REVOKED'
    | 'FAN_CHANGED'
    | 'DNB_DOMAIN_LOOKUP_FAILED'
    | 'DNB_DUNS_MISMATCH'
    | 'DNB_UNAVAILABLE'
    | 'DOMAIN_MISMATCH'
    | 'FAN_NOT_FOUND'
    | 'FAN_NOT_ELIGIBLE'
    | 'FAN_VERIFICATION_INCOMPLETE'
    | 'FAN_READY_TO_LINK';
  verificationStatusReasonNote?: string;
  settings?: OrganizationSettingsDto;
  draftReasonCode?: 'MIGRATION';
  draftReasonMessage?: string;
  /** Classification of the organization */
  orgType?: 'TEST' | 'DEMO' | 'DEALER' | 'CUSTOMER';
  oviAccountId?: string;
  oviFleetId?: string;
  oviChangeSequence?: string;
};
export type GmPageOrganizationDto = {
  items: OrganizationDto[];
  total_items?: number;
  continuation_token?: string;
};
export type GmResponseCommonGmPageOrganizationDto = {
  result?: GmPageOrganizationDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OrganizationFanResponse = {
  /** Unique identifier of the organization */
  organizationId?: string;
  /** Fleet Account Number (FAN) of the organization */
  fan?: string;
  /** Organization settings */
  settings?: OrganizationSettings;
};
export type GmResponseCommonListOrganizationFanResponse = {
  result?: OrganizationFanResponse[];
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommonOrganizationDto = {
  result?: OrganizationDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmPageFleetResponse = {
  items: FleetResponse[];
  total_items?: number;
  continuation_token?: string;
};
export type GmResponseCommonGmPageFleetResponse = {
  result?: GmPageFleetResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type PaginatedDataResponseOrganizationResponseV20241120 = {
  items?: OrganizationResponseV20241120[];
  continuation_token?: string;
  total_items?: number;
};
export type GmResponseCommonPaginatedDataResponseOrganizationResponseV20241120 =
  {
    result?: PaginatedDataResponseOrganizationResponseV20241120;
    targetUrl: string;
    __bd: boolean;
    success: boolean;
    unauthorizedRequest: boolean;
    errors: GmResponseError[];
    traceId?: string;
  };
export type OpportunitiesResponse = {
  modelYear?: string;
  signedAgreementDate?: string;
  signedAgreementId?: string;
};
export type CapsResponse = {
  opportunities?: OpportunitiesResponse[];
  isFanNumberValid?: boolean;
  fanNumber?: string;
  accountOwnerFullName?: string;
  accountOwnerEmailAddress?: string;
  accountOwnerPhoneNumber?: string;
  accountPrimaryContactName?: string;
  accountPrimaryContactEmail?: string;
  accountPrimaryContactNumber?: string;
  gfssResponseStatus?: number;
  gfssErrorMessage?: string;
};
export type GmResponseCommonCapsResponse = {
  result?: CapsResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommonListOrganizationResponseV20230717 = {
  result?: OrganizationResponseV20230717[];
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type FleetConfigurationResponseV2 = {
  id?: string;
  name?: string;
  description?: string;
  organization?: HierarchyObjectView;
  hub?: HierarchyObjectView;
  creationDate?: string;
  configuration?: ConfigurationValueDto;
  organizationEntityConfiguration?: OrganizationEntityConfigurationDto;
};
export type GmResponseCommonFleetConfigurationResponseV2 = {
  result?: FleetConfigurationResponseV2;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OrganizationResponseV20211115 = {
  id?: string;
  name: string;
  emailAddress: string;
  address: Address;
  creationDate?: string;
  activationDate?: string;
  status?: string;
  phoneNumber: string;
  primaryContact?: PrimaryContact;
  /** Country of operation of the organization */
  countryOfOperation?: 'US' | 'MX' | 'CA';
};
export type GmResponseCommonListOrganizationResponseV20211115 = {
  result?: OrganizationResponseV20211115[];
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OrganizationEntityResponse = {
  id?: string;
  organization?: HierarchyObjectView;
  name?: string;
  description?: string;
  address?: Address;
  creationDate?: string;
  organizationEntityConfiguration?: OrganizationEntityConfigurationDto;
};
export type GmResponseCommonListOrganizationEntityResponse = {
  result?: OrganizationEntityResponse[];
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommonOrganizationEntityResponse = {
  result?: OrganizationEntityResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type FleetResponseDeprecated = {
  id?: string;
  name?: string;
  description?: string;
  organization?: HierarchyObjectView;
  hub?: HierarchyObjectView;
  creationDate?: string;
  configuration?: ConfigurationValueDto;
  organizationEntityConfiguration?: OrganizationEntityConfigurationDto;
};
export type GmResponseCommonListFleetResponseDeprecated = {
  result?: FleetResponseDeprecated[];
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommonOrganizationViewJson = {
  result?: OrganizationViewJson;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommonOrganizationResponseV20211115 = {
  result?: OrganizationResponseV20211115;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type StatsV1 = {
  hubCount?: number;
  fleetCount?: number;
};
export type GmResponseCommonStatsV1 = {
  result?: StatsV1;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OrganizationMinViewDto = {
  id?: string;
  name?: string;
};
export type GmResponseCommonListOrganizationMinViewDto = {
  result?: OrganizationMinViewDto[];
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export const {
  useGetPartnerIdQuery,
  useUpdatePartnerIdMutation,
  useUpdateVerificationStatusMutation,
  useGetAutoOnboardingSettingsQuery,
  useUpdateAutoOnboardingSettingsMutation,
  useUpdateFleetV20250114Mutation,
  useUpdateOrganizationV20241204Mutation,
  useUpdateOrganizationV20230717Mutation,
  useUpdateFleetsByOrganizationIdAndFleetIdMutation,
  useSyncOviTrialSubscriptionMutation,
  useValidateMigratedOviTrialStartDateMutation,
  useCloseOrganizationMutation,
  useReconcileCloseOrganizationsMutation,
  useVerifyFanMutation,
  useValidateMigratedOviFleetsMutation,
  useValidateMigratedOviBusinessAccountMutation,
  useSubmitEnrollmentMutation,
  useGetMigratedOviFleetsQuery,
  useSyncOviFleetsMutation,
  useActivateOrganizationMutation,
  useLookupEnrollmentMutation,
  useSyncOviBusinessAccountMutation,
  useGetOrganizationsInfoV20260120Mutation,
  useLookupOrganizationByInfoMutation,
  useLookupOrganizationByRawAddressInfoMutation,
  useEnrollAutomaticMutation,
  useEnrollForReviewMutation,
  useAcceptTermsMutation,
  useEnrollAsCustomerMutation,
  useDeclineEnrollmentMutation,
  useApproveEnrollmentMutation,
  useEnrollAsAdminMutation,
  useUpdateOrgDefaultFleetMutation,
  useCreateFleetMutation,
  useCheckIfFleetConfigHasChangedMutation,
  useGetOrganizationsInfoMutation,
  useGetCloseStatusQuery,
  useGetEnrollmentStatusQuery,
  useGetMigratedOviAccountsQuery,
  useGetOrganizationFanDetailsQuery,
  useGetOrganizationByOrgIdQuery,
  useGetAllFleetsQuery,
  useGetFleetByIdQuery,
  useGetAllOrganizationsQuery,
  useGetOrgByIdQuery,
  useGetCapDetailsQuery,
  useGetDocumentQuery,
  useGetAllOrganizationsWithTypeQuery,
  useGetOrganizationByIdWithTypeQuery,
  useGetFleetByIdV2Query,
  useGetAllOrganizations1Query,
  useGetAllHubsQuery,
  useGetHubByIdQuery,
  useGetAllFleets1Query,
  useGetFleetById1Query,
  useGetFleetChildrenQuery,
  useGetHubChildrenQuery,
  useGetOrganizationChildrenQuery,
  useGetOrganizationByIdQuery,
  useGetOrganizationStatsByIdQuery,
  useGetAllFleetsByOrganizationIdQuery,
  useGetTopLevelOrganizationsQuery,
} = injectedRtkApi;
